import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidationErrors, FormGroup } from '@angular/forms';
import {CustomValidationService} from "../services/custom-validation.service";

@Directive({
  selector: '[matchEmail]',
  providers: [{ provide: NG_VALIDATORS, useExisting: MatchEmailDirective, multi: true }]
})
export class MatchEmailDirective implements Validator {
  @Input('matchEmail') MatchEmail: string[] = [];

  constructor(private customValidator: CustomValidationService) { }

  validate(formGroup: FormGroup): ValidationErrors {
    return this.customValidator.MatchEmail(this.MatchEmail[0], this.MatchEmail[1])(formGroup);
  }
}
